module.exports = __webpack_public_path__ + "static/media/master-card.b4aa10d2.png";